(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["breadcrumb~index"],{

/***/ 153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "classnames"
var external_classnames_ = __webpack_require__(2);
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_);

// CONCATENATED MODULE: ./src/components/breadcrumb/breadcrumb.jsx
// 样式文件
// import './style/index.scss';

/* harmony default export */ var breadcrumb = ({
  name: 'MegBreadcrumb',
  props: {
    className: {
      type: String
    },
    canReturn: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    click: function click() {
      var slots = this.$slots.default.filter(function (child) {
        return child.tag;
      });
      var returnOptions = slots[slots.length - 2].componentOptions;

      if (returnOptions.listeners) {
        returnOptions.listeners.click();
      } else if (returnOptions.propsData) {
        window.open(returnOptions.propsData.href, '_self');
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    return h("nav", {
      "class": external_classnames_default()('meg-breadcrumb', this.className)
    }, [this.canReturn && h("span", {
      "class": 'meg-breadcrumb-return',
      on: {
        "click": this.click
      }
    }, [h("meg-icon", {
      attrs: {
        name: 'megui-left'
      }
    })]), this.$slots.default.map(function (element) {
      return element;
    })]);
  }
});
// CONCATENATED MODULE: ./src/components/breadcrumb/breadcrumb-item.jsx

/* harmony default export */ var breadcrumb_item = ({
  name: 'MegBreadcrumbItem',
  props: {
    className: {
      type: String
    },
    href: {
      type: String
    },
    active: {
      type: Boolean,
      default: true
    }
  },
  mounted: function mounted() {},
  beforeCreate: function beforeCreate() {},
  methods: {
    click: function click(e) {
      if (Object.keys(this._events).length) {
        e.preventDefault();
        this.$emit('click');
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    return h("span", [this.href !== undefined && this.active ? h("a", {
      "class": external_classnames_default()('meg-breadcrumb-item', this.className),
      on: {
        "click": this.click
      },
      attrs: {
        href: this.href
      }
    }, [this.$slots.default]) : h("span", {
      "class": external_classnames_default()('meg-breadcrumb-item', this.className)
    }, [this.$slots.default]), h("span", {
      "class": 'meg-breadcrumb-separator'
    }, ["/"])]);
  }
});
// CONCATENATED MODULE: ./src/components/breadcrumb/index.jsx


breadcrumb.Item = breadcrumb_item;

breadcrumb.install = function (Vue) {
  Vue.component(breadcrumb.name, breadcrumb);
  Vue.component(breadcrumb_item.name, breadcrumb_item);
};

/* harmony default export */ var components_breadcrumb = __webpack_exports__["default"] = (breadcrumb);

/***/ })

}]);